import ArcoVue from '@arco-design/web-vue'
import { createApp } from 'vue'
// 额外引入图标库
import ArcoVueIcon from '@arco-design/web-vue/es/icon'
import App from './App'
import router from './router'
import store from './store'

// 引入v-echart(  按需导入  )
import ECharts from '@/utils/v-echart'

// 引入刷新按钮组件，注册成全局组件
import RefreshPage from '@/components/global/RefreshPage.vue'
// 引入分页组件，注册成全局组件
import Pagination from '@/components/global/Pagination.vue'
// 引入多选下拉组件，注册成全局组件
import HHxcSelect from '@/components/HHxcSelect.vue'
import TDesignChat from '@tdesign-vue-next/chat'
// 下拉和搜索输入框
import InputGroup from '@/components/InputGroup.vue'
import '@/utils/checkUpdate'
// 引入vxe-table
import '@/assets/styles/tailwind.css'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'

import VxeUI from 'vxe-pc-ui'
import 'vxe-pc-ui/lib/style.css'
// 修改vxe-table下拉组件的icon
VxeUI.formats.add('num', {
  tableCellFormatMethod: ({ cellValue }, digit) => {
    return formatThouNum(cellValue, digit)
  },
})
VxeUI.formats.add('yes', {
  tableCellFormatMethod: ({ cellValue }, trueNum = 0) => {
    return cellValue === trueNum ? '是' : '否'
  },
})
VXETable.setConfig({
  icon: {
    SELECT_OPEN: 'vxe-icon--arrow-bottom rotate180',
    SELECT_CLOSE: 'vxe-icon--arrow-bottom',
  },
  size: 'mini',
  table: {
    align: 'left',
    scrollY: {
      enabled: true,
      gt: 100,
    },
    scrollX: {
      enabled: false,
      gt: 30,
    },
  },
})

// icon-svg
import '@/icons'
import IconSvg from './components/icon-svg/index.vue'

import '@/assets/theme/index.less'
// import 'default-passive-events'

// import permisssion
import { isAuth } from '@/utils'

// 引入
import vue3JsonExcel from 'vue3-json-excel'

// 引入全局指令
import directives from '@/directives'
import { formatThouNum } from '@/utils/format'
import { debounce } from 'lodash-es'

const app = createApp(App)

// 挂在权限方法
app.config.globalProperties.isAuth = isAuth
// v-echart  全局注册组件（也可以使用局部注册）
app.component('v-chart', ECharts)
// 刷新按钮组件
app.component('RefreshPage', RefreshPage)
// 多选下拉组件
app.component('HHxcSelect', HHxcSelect)
// 分页组件
app.component('Pagination', Pagination)
// 下拉和搜索输入框
app.component('InputGroup', InputGroup)
// icon-svg
app.component('IconSvg', IconSvg)

// 注册全局指令
directives(app)

app
  .use(store)
  .use(router)
  .use(ArcoVue, {
    // 用于改变使用组件时的前缀名称
    // componentPrefix: 'h',
  })
  // .use(TDesign)
  .use(TDesignChat)
  .use(ArcoVueIcon)
  .use(VxeUI)
  .use(VXETable)
  .use(vue3JsonExcel)
  .mount('#app')

// app.vue写在script里面  main.js写在app挂在完之后

const _ResizeObserver = window.ResizeObserver
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 10)
    super(callback)
  }
}
